import { GET_ALL_COURSE_COACH } from '../actions/types'

const initialState = {
  course_coach: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  loading: true,
}

export default function coach(state = initialState, actions) {
  const { type, payload } = actions
  switch (type) {
    case GET_ALL_COURSE_COACH:
      return {
        ...state,
        course_coach: payload,
        loading: false,
      }
    default:
      return state
  }
}
